import { getApiService, WEB_REQUEST_TYPE } from "../../../helpers/apiService";
import { SUPPORT_TICKET_URL } from "../../../config/service";

export const createSupportTicketApi = (params) => {
  return getApiService(WEB_REQUEST_TYPE.POST, SUPPORT_TICKET_URL, params);
};
